/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butunterlagenvollstaendig4Inputs */

const de__field_butunterlagenvollstaendig4 = /** @type {(inputs: _Field_Butunterlagenvollstaendig4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT-Unterlagen vollständig`)
};

/**

* @param {_Field_Butunterlagenvollstaendig4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butunterlagenvollstaendig4 = /** @type {((inputs?: _Field_Butunterlagenvollstaendig4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butunterlagenvollstaendig4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butunterlagenvollstaendig4(inputs)
});
export { _field_butunterlagenvollstaendig4 as "_field_BuTUnterlagenVollstaendig" }